import {
    IconAirplane,
    IconBank,
    IconBusiness,
    IconChange,
    IconDining,
    IconDollar,
    IconDonate,
    IconEntertainment,
    IconGuide,
    IconHelp,
    IconHome,
    IconMedical,
    IconMerchandise,
    IconPartnership,
    IconReceipt
} from '@americanexpress/dls-icons';
import { Categorizable, CategoryModel } from 'src/types/category.model';
import FormatService from 'src/services/format.service';
import _ from 'lodash';
import { BUDGET_OVERALL_ID } from 'src/services/budget.service';

export const icons: { [key: string]: any } = {
    Charity: IconDonate,
    Education: IconGuide,
    Family: IconPartnership,
    Financial: IconBank,
    'Food & Dining': IconDining,
    'Fun & Entertainment': IconEntertainment,
    'Health & Wellness': IconMedical,
    Home: IconHome,
    'Income & Deposits': IconDollar,
    Miscellaneous: IconReceipt,
    Services: IconBusiness,
    Shopping: IconMerchandise,
    Transfers: IconChange,
    'Travel & Transportation': IconAirplane,
    'Needs Categorization': IconHelp
};

export function getIcon(categoryName: string): any {
    return icons[categoryName] || IconHelp;
}

export function categoryIsCustom(planUid: string): boolean {
    return planUid !== undefined;
}

export function getParentCategoryName(categoryParentId: string, categories: CategoryModel[]): string {
    return categories.find((c) => c.id === categoryParentId)?.name || '';
}

export function getCategoryTagName(category: CategoryModel, categories: CategoryModel[]): string {
    if (categoryIsCustom(category.planUid)) {
        const parentCategory = getParentCategoryName(category.parentId, categories).toLowerCase();
        // when a custom category name may have PII, we substitute it with 'custom' for Adobe tracking calls
        return FormatService.formatTag(`custom-${parentCategory}`);
    }
    return FormatService.formatTag(category.name);
}

export function getCategoryName(id: string, categories: CategoryModel[]): string {
    return categories?.find((cat) => cat.id === id)?.name ?? '';
}

export function groupByCategory(
    items: Categorizable[],
    categories: CategoryModel[],
    sortedBy: _.ListIteratee<Categorizable>
): Categorizable[][] {
    if (items?.length === 0 || categories?.length === 0) return [];
    const parentItems = _.sortBy(
        items?.filter((item) => {
            const category = categories?.find((cat) => cat.id === item.groupId);
            return item.groupId !== BUDGET_OVERALL_ID && !category?.parentId;
        }),
        sortedBy
    );
    return parentItems.map((parentItem) => {
        let childItems = _.sortBy(
            items?.filter((item) => {
                const category = categories?.find((cat) => cat.id === item.groupId);
                return category && category.parentId === parentItem.groupId;
            }),
            sortedBy
        );
        childItems = childItems.map((childItem) => {
            // save the parent groupId on the child so that we don't have to iterate through
            // all the categories to find this id again
            return { ...childItem, parentGroupId: parentItem.groupId };
        });
        return [parentItem, ...childItems];
    });
}
